const massTransfersData = [
  { id: 1, name: "Pago de Nómina" },
  { id: 2, name: "Transferencia General" },
  { id: 3, name: "Transferencia Internacional" },
  { id: 4, name: "Transferencia Interna" },
  { id: 5, name: "Pago de Servicios" },
];

const pagoNominas = [
  {
    id: 1,
    empleado: "Juan Pérez",
    puesto: "Analista",
    salario: 1500,
    fechaPago: "2025-01-15",
  },
  {
    id: 2,
    empleado: "María López",
    puesto: "Desarrolladora",
    salario: 1800,
    fechaPago: "2025-01-15",
  },
  {
    id: 3,
    empleado: "Carlos Ramírez",
    puesto: "Gerente",
    salario: 2500,
    fechaPago: "2025-01-15",
  },
  {
    id: 4,
    empleado: "Ana González",
    puesto: "Asistente",
    salario: 1200,
    fechaPago: "2025-01-15",
  },
  {
    id: 5,
    empleado: "Luis Torres",
    puesto: "Técnico",
    salario: 1300,
    fechaPago: "2025-01-15",
  },
  {
    id: 6,
    empleado: "Sofía Martínez",
    puesto: "Administradora",
    salario: 1700,
    fechaPago: "2025-01-15",
  },
  {
    id: 7,
    empleado: "Pedro Sánchez",
    puesto: "Supervisor",
    salario: 2000,
    fechaPago: "2025-01-15",
  },
  {
    id: 8,
    empleado: "Gabriela Fernández",
    puesto: "Diseñadora",
    salario: 1600,
    fechaPago: "2025-01-15",
  },
  {
    id: 9,
    empleado: "Fernando Castillo",
    puesto: "Contador",
    salario: 2100,
    fechaPago: "2025-01-15",
  },
  {
    id: 10,
    empleado: "Laura Moreno",
    puesto: "Soporte Técnico",
    salario: 1400,
    fechaPago: "2025-01-15",
  },
];

const pagos = [
  {
    id: 1,
    empleado: "Juan Pérez",
    puesto: "Analista",
    salario: 1500,
    fechaPago: "2025-01-15",
    montoEditable: "",
  },
  {
    id: 2,
    empleado: "María López",
    puesto: "Desarrolladora",
    salario: 1800,
    fechaPago: "2025-01-15",
    montoEditable: "",
  },
  {
    id: 3,
    empleado: "Carlos Ramírez",
    puesto: "Gerente",
    salario: 2500,
    fechaPago: "2025-01-15",
    montoEditable: "",
  },
  {
    id: 4,
    empleado: "Ana González",
    puesto: "Asistente",
    salario: 1200,
    fechaPago: "2025-01-15",
    montoEditable: "",
  },
  {
    id: 5,
    empleado: "Luis Torres",
    puesto: "Técnico",
    salario: 1300,
    fechaPago: "2025-01-15",
    montoEditable: "",
  },
  {
    id: 6,
    empleado: "Sofía Martínez",
    puesto: "Administradora",
    salario: 1700,
    fechaPago: "2025-01-15",
    montoEditable: "",
  },
  {
    id: 7,
    empleado: "Pedro Sánchez",
    puesto: "Supervisor",
    salario: 2000,
    fechaPago: "2025-01-15",
    montoEditable: "",
  },
  {
    id: 8,
    empleado: "Gabriela Fernández",
    puesto: "Diseñadora",
    salario: 1600,
    fechaPago: "2025-01-15",
    montoEditable: "",
  },
  {
    id: 9,
    empleado: "Fernando Castillo",
    puesto: "Contador",
    salario: 2100,
    fechaPago: "2025-01-15",
    montoEditable: "",
  },
  {
    id: 10,
    empleado: "Laura Moreno",
    puesto: "Soporte Técnico",
    salario: 1400,
    fechaPago: "2025-01-15",
    montoEditable: "",
  },
];

export { massTransfersData, pagoNominas, pagos };
